const backToTopSelector = 'button#backtotop';

export function initBackToTop() {
  const backToTopButton = document.querySelector(backToTopSelector);

  if (!backToTopButton) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  backToTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion.matches ? 'auto' : 'smooth',
    });
  });
}
